export let CrystallizeCustomerUpdateOp;

(function (CrystallizeCustomerUpdateOp) {
  CrystallizeCustomerUpdateOp[CrystallizeCustomerUpdateOp["ADD_PAYMENT_METHOD"] = 0] = "ADD_PAYMENT_METHOD";
  CrystallizeCustomerUpdateOp[CrystallizeCustomerUpdateOp["DELETE_PAYMENT_METHOD"] = 1] = "DELETE_PAYMENT_METHOD";
})(CrystallizeCustomerUpdateOp || (CrystallizeCustomerUpdateOp = {}));